import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import { RequestAccessModal } from '@/widgets/RequestAccessModal';

export const getGetStartedBlockData = (t: TFunction) => {
  const blocks = t('mainPage.getStarted', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
    highlight: string;
    buttonText: string;
  }>;

  return [
    {
      heading: blocks[0]!.heading,
      description: blocks[0]!.description,
      highlight: [blocks[0]!.highlight],
      button: (
        <RedirectToAppButton
          buttonText={blocks[0]!.buttonText}
          dataLayer={{ data: { redirected_from: 'main_page_get_started_block' } }}
          pageName='signup'
          size='md'
        />
      ) as ReactNode,
    },
    {
      heading: blocks[1]!.heading,
      description: blocks[1]!.description,
      highlight: [blocks[1]!.highlight],
      button: (
        <RequestAccessModal
          buttonText={blocks[1]!.buttonText}
          variant='outline'
        />
      ) as ReactNode,
    },
  ];
};
